import React from 'react';
import { scrubFormatting } from '../../../utils/numberFormat';
import Panel from 'react-bootstrap/lib/Panel';
import Row from '@coxautokc/fusion-ui-components/lib/Row';
import Col from '@coxautokc/fusion-ui-components/lib/Col';
import Alert from 'react-bootstrap/lib/Alert';
import { savings } from '../../../propTypes';

const FuelSavingsResults = ({ savings }) => {
  const savingsExist = scrubFormatting(savings.monthly) > 0;
  const resultLabel = savingsExist
    ? 'Great! Your new vehicle will save you money on gas!'
    : 'Oh no! Your new vehicle is not providing any savings!';
  const resultType = savingsExist ? 'success' : 'danger';

  return (
    <div>
      <Row>
        <Col lg={12}>
          <Alert bsStyle={resultType}>{resultLabel}</Alert>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={4} lg={4}>
          <Panel>
            <b>Monthly</b> <span className="pull-right">{savings.monthly}</span>
          </Panel>
        </Col>
        <Col xs={12} md={4} lg={4}>
          <Panel>
            <b>Annual</b> <span className="pull-right">{savings.annual}</span>
          </Panel>
        </Col>
        <Col xs={12} md={4} lg={4}>
          <Panel>
            <b>Three Year</b>{' '}
            <span className="pull-right">{savings.threeYear}</span>
          </Panel>
        </Col>
      </Row>
    </div>
  );
};

FuelSavingsResults.propTypes = {
  savings: savings.isRequired
};

export default FuelSavingsResults;



// WEBPACK FOOTER //
// ./src/components/pages/ReduxExamplePage/FuelSavingsResults.js